import { useEffect } from 'react';

export default function Product() {

useEffect(() => {
       window.scrollTo(0, 0); // Scroll to the top of the page
     }, []);



  return (
    <div>Product</div>
  )
}
